// v19.30 — Set-password page for auto-created accounts.
// Route: /set-password?token=…
// Token issued by the manual-purchase pipeline and included in the
// buyer's welcome email.
import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import API from "../api";
import GlobalNav from "../components/GlobalNav";

export default function SetPasswordPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!token) { toast.error("Missing token"); return; }
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (password !== confirm) { toast.error("Passwords don't match"); return; }
    setBusy(true);
    try {
      const { data } = await API.post("/store/auth/set-password", { token, password });
      localStorage.setItem("crow_token", data.token);
      toast.success("Password set — welcome to C.R.O.W.");
      nav("/my-beats");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not set password");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-6 relative">
      <div className="absolute top-5 left-6"><GlobalNav /></div>
      <div className="w-full max-w-sm space-y-3 rounded-2xl bg-[#0a0a0a] border border-[#1f1f1f] p-6" data-testid="set-password-card">
        <h1 className="font-display font-bold text-2xl">Set your password</h1>
        <p className="text-xs text-white/50">Finish setting up your C.R.O.W. account so you can access your library and generate beats.</p>
        <input type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-3 py-2 rounded-md bg-black border border-[#262626]" data-testid="set-password-input" />
        <input type="password" placeholder="Confirm password" value={confirm} onChange={(e) => setConfirm(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") submit(); }} className="w-full px-3 py-2 rounded-md bg-black border border-[#262626]" data-testid="set-password-confirm" />
        <button onClick={submit} disabled={busy} className="w-full py-2 rounded-md bg-emerald-500 text-black font-bold disabled:opacity-50" data-testid="set-password-submit">{busy ? "Setting…" : "Set password"}</button>
      </div>
    </div>
  );
}
